import gql from 'graphql-tag'

export default gql`
{
  trackings(    
    sort: SCANNEDAT_DESC
    limit: 10000
    )
  {
    _id
    carrier
    code
    status
    scannedAt
    label {
      app
      group
      recipient
      address
    }
  }
}

`



// WEBPACK FOOTER //
// ./src/graphql/queries/trackings.js